(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    var overlay=document.querySelector('[data-cuddleclub-demo]');if(!overlay)return;
    var shell=overlay.querySelector('[data-cc-shell]');
    var frame=overlay.querySelector('[data-cc-frame]');
    var tpl=overlay.querySelector('[data-cc-srcdoc]');
    var loaded=false;var lastFocus=null;
    function ensureLoaded(){if(loaded)return;frame.srcdoc=tpl.innerHTML;loaded=true}
    function setDevice(mode){
      var mobile=mode==='mobile';shell.classList.toggle('is-mobile',mobile);
      overlay.querySelectorAll('[data-cc-device]').forEach(function(btn){var active=btn.getAttribute('data-cc-device')===mode;btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',String(active))});
      if(loaded){try{frame.contentWindow.scrollTo(0,0)}catch(e){}}
    }
    function open(){lastFocus=document.activeElement;ensureLoaded();overlay.hidden=false;overlay.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';setDevice(window.innerWidth<=760?'mobile':'desktop')}
    function close(){overlay.hidden=true;overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus()}
    window.ThemevoEmbeddedDemo=window.ThemevoEmbeddedDemo||{};var prev=window.ThemevoEmbeddedDemo.open;window.ThemevoEmbeddedDemo.open=function(name){if(name==='cuddleclub'){open();return}if(typeof prev==='function')prev(name)};
    document.addEventListener('click',function(e){
      var trigger=e.target.closest&&e.target.closest('[data-live-demo-link][data-embedded-demo="cuddleclub"]');if(trigger){e.preventDefault();e.stopPropagation();open();return}
      if(overlay.hidden)return;
      if(e.target.closest('[data-cc-close]')){e.preventDefault();close();return}
      var device=e.target.closest('[data-cc-device]');if(device){e.preventDefault();setDevice(device.getAttribute('data-cc-device'));return}
    },true);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!overlay.hidden)close()});
  })
})();
